import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { CriterionEvaluation } from '@services/auditService';

/**
 * REV-1074: says that a saved attestation note started as an AI draft, and
 * whether the reviewer changed it before approving. Text, not colour or an
 * icon alone. Nothing for a note a person wrote.
 */
export default function AiDraftedNoteLabel({
  criterion,
}: {
  criterion: Pick<
    CriterionEvaluation,
    'attestation_note' | 'attestation_note_ai_call_id' | 'attestation_note_ai_edited'
  >;
}) {
  const { t } = useTranslation();
  if (!criterion.attestation_note || !criterion.attestation_note_ai_call_id) {
    return null;
  }
  return (
    <Typography variant="caption" color="text.secondary" component="p" sx={{ mt: 0.5 }}>
      {criterion.attestation_note_ai_edited
        ? t(
            'attestation.aiDrafted.edited',
            'Drafted with AI assistance, then edited and approved by the reviewer.'
          )
        : t(
            'attestation.aiDrafted.unchanged',
            'Drafted with AI assistance and approved without changes.'
          )}
    </Typography>
  );
}
